
import httpClient from '../httpClient'

class ConnexionDataService {
  login (data) {
    return httpClient.post('/login', data)
  }
}

export default new ConnexionDataService()
